import axiosInstanceAdmin from "../Common/Axios/axiosInstanceAdmin";
import API from "../Common/Endpoint/serviceConstrants";
import { clientType } from "../Utility/Utility";

const commonHeaders = {
  Userid: process.env.REACT_APP_USER_ID,
  Password: process.env.REACT_APP_PASSWORD,
};
export const translationApi = async () => {
  const { data = {} } = await axiosInstanceAdmin.get(API.translationApi, {
    headers: {
      ...commonHeaders,
    },
    params: {
      resourceType: clientType,
    },
  });
  return data;
};
